
import SignupMarketing from "./Components/SignupMarketing";
import SignupForm from "./Components/SignupForm";

const Signup = () => {

    return (
        <div className='w-full flex'>
            <div className='hidden md:block w-[40vw]'>
                <SignupMarketing />
            </div>
            <div className='w-full md:w-[60vw]'>
                <SignupForm />
            </div>
        </div>
    );
}

export default Signup;